import React from 'react';
import { SetupHelpPanel } from './SetupHelpPanel';

/**
 * AccountIdentifierSetupHelp Component
 *
 * Displays instructions for finding the Snowflake Account Identifier.
 *
 * @component
 * @example
 * ```tsx
 * <AccountIdentifierSetupHelp />
 * ```
 */
export const AccountIdentifierSetupHelp: React.FC = () => {
  const querySQL = `SELECT CURRENT_ORGANIZATION_NAME() || '-' || CURRENT_ACCOUNT_NAME();`;

  return (
    <SetupHelpPanel
      id="account-identifier-help"
      title="How to get the account identifier?"
      purpose="In the Account field, you need to provide your Account Identifier from Snowflake."
      sqlBlocks={[
        {
          code: querySQL,
          runAsRole: 'Any role',
          label: 'Copy query',
        },
      ]}
      nextSteps={[
        'Log in to your Snowflake account and open the account selector (located in the lower-left corner).',
        'Hover over the account to expand a menu on the right.',
        'Select "View account details" for the desired account (if you have multiple accounts, you may need to scroll to find the correct one).',
        'The Account Details dialog will display information about the account, including the Account Identifier.',
      ]}
      notes={['Alternatively, run the query above in Snowflake to get your Account Identifier.']}
      storageKey="account-identifier-help-expanded"
    />
  );
};
